<div *ngIf="reportType == 'InDetail-Officer'">
    <div class="report-container" id="print-section">
        <!-- <div class="report-header" 
             style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
            <h1 class="company-name" style="margin: 0; font-size: 18px; flex: 1; text-align: left;">
                Vivek Saptahik
            </h1>
            <h2 class="report-title" style="margin: 0; font-size: 18px; flex: 2; text-align: center;">
                Advertisement Payment Receipt Ledger
            </h2>
            <div class="report-meta" style="flex: 1; text-align: right; font-size: 18px;">
                <span class="report-type">InDetail Officer Report </span>
                <span class="date-range">
                    <br>
                    Date: {{ startDate | date: 'dd-MM-yyyy' }} to {{ endDate | date: 'dd-MM-yyyy' }}
                </span>
            </div>
        </div> -->
        <table class="report-header-table" style="width: 100%; border-collapse: collapse; margin-bottom: 0;">
    <tr>
        <td style="width: 25%; padding: 12px 10px; border: 1px solid #0d0d0e; background: #f8f9fa; text-align: left; font-size: 16px; font-weight: bold;">
            Vivek Saptahik
        </td>
        <td style="width: 50%; padding: 12px 10px; border: 1px solid #0d0d0e; border-left: none; background: #f8f9fa; text-align: center; font-size: 16px; font-weight: bold;">
            Advertisement Payment Receipt Ledger
        </td>
        <td style="width: 25%; padding: 12px 10px; border: 1px solid #0d0d0e; border-left: none; background: #f8f9fa; text-align: right; font-size: 13px;">
            <strong>InDetail Officer Report</strong><br>
            Date: {{ startDate | date: 'dd-MM-yyyy' }} to {{ endDate | date: 'dd-MM-yyyy' }}
        </td>
    </tr>
</table>

        <div class="table-responsive">
            <table class="styled-table table-bordered">
                <thead>
                    <tr>
                        <th style="width: 8%;">Receipt<br>No</th>
                        <th style="width: 8%;">Receipt<br>Date</th>
                        <th style="width: 8%;">Entry<br>Date</th>
                        <th style="width: 15%;">Advertiser Name</th>
                        <th style="width: 12%;">Issue<br>Name</th>
                        <th style="width: 8%;">Issue<br>Date</th>
                        <th style="width: 10%;">Invoice<br>Number</th>
                        <th style="width: 8%;">Invoice<br>Date</th>
                        <th style="width: 10%;">Invoice<br>Net Amount</th>
                        <th style="width: 10%;">Received<br>Amount</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let data of PaymentadvtOffInDFormBenas; let i = index">
                        <tr class="office-header">
                            <td colspan="3"><strong>Office Representative</strong></td>
                            <td colspan="7"><strong>{{data.off_rep_name}}</strong></td>
                        </tr>
                        
                        <ng-container *ngFor="let repData of data.rep_data; let j = index">
                            <tr class="rep-header"> 
                                <td colspan="8"><strong>{{repData.rep_name}}</strong></td>
                                <td colspan="2" style="text-align: end;"></td>
                            </tr>
                            
                            <tr class="data-row" *ngFor="let advtData of repData.advt_data; let k = index">
                                <td class="nowrap">{{advtData.rcpt_no}}</td>
                                <td class="nowrap">{{advtData.rcpt_date}}</td>
                                <td class="nowrap">{{advtData.entry_date}}</td>
                                <td class="nowrap text-left" [title]="advtData.advt_name">{{advtData.advt_name | slice :0:30}}</td>
                                <td class="nowrap">{{advtData.DS_ISSUENAME | slice : 0:20}}</td>
                                <td class="nowrap">{{advtData.DS_ISSUEDATE}}</td>
                                <td class="nowrap">{{advtData.advt_invoice_no}}</td>
                                <td class="nowrap">{{advtData.advt_invoice_date}}</td>
                                <td class="nowrap text-right">{{advtData.net_amt}}</td>
                                <td class="nowrap text-right">{{advtData.rcv_amt}}</td>
                            </tr>
                            
                            <tr class="rep-total">
                                <td colspan="8"><strong>Rep Total:</strong></td>
                                <td colspan="2" style="text-align: end;"><strong>{{repData.rep_total}}</strong></td>
                            </tr>
                        </ng-container>
                        
                        <tr class="office-total">
                            <td colspan="8"><strong>Office Total:</strong></td>
                            <td colspan="2" style="text-align: end;"><strong>{{data.total}}</strong></td>
                        </tr>
                    </ng-container>
                </tbody>
                <tfoot>
                    
                </tfoot>
                <tr class="grand-total">
                        <td colspan="8"><strong>Grand Total:</strong></td>
                        <td colspan="2" style="text-align: end;"><strong>{{(PaymentadvtOffInDTotal2 * 1).toFixed(2)}}</strong></td>
                    </tr>
            </table>
        </div>
    </div>

    <div class="button-container noPrint">
        <button class="modern-btn btn-primary-modern noPrint" 
                (click)="exportExcel('Contract_InDetails_Report')" 
                mat-raised-button color="primary">
            📊 Export
        </button>

        <button class="modern-btn btn-primary-modern noPrint"
                mat-raised-button color="primary"
                (click)="printPage4()">
            🖨️ Print
        </button>

        <button class="modern-btn btn-secondary-modern noPrint" 
                mat-button mat-dialog-close>
            ❌ Close
        </button>
    </div>
</div>